import type DecafOrderType from '../types/DecafOrder';
import Sample from 'productionOrders/models/Sample';
import Ico from 'decaf/types/Ico';

import { createSampleFactory } from 'utils/factories/createSampleFactory';
import DecafSampleBuidler from '../builders/DecafSampleBuilder';

class DecafOrder {
  public id: number;
  public state: string;
  public sample: Sample;
  public ico: Ico;

  public constructor({ id, state, ico }: DecafOrderType) {
    this.id = id;
    this.state = state;
    this.ico = ico;

    const sampleBuilder = new DecafSampleBuidler(ico.sample, id);

    this.sample = createSampleFactory(ico.sample, sampleBuilder);
  }

  public get rejected(): boolean {
    return this.state === 'rejected';
  }
}

export default DecafOrder;
